import styled from 'styled-components';

export const ValueArea = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
  margin: 0 5px;
`;
